<template>
  <section class="shield-home s-about-services">
    <ShieldHeader />

    <div class="container-wide">
      <div class="content">
        <ShieldNavigation />

        <div class="banner">
          <picture>
            <source
              media="(max-width: 480px)"
              srcset="../assets/shield-banners/shield-bios-banner-02-square.jpg"
              alt=""
            />
            <source
              media="(min-width:481px)"
              srcset="../assets/shield-banners/shield-bios-banner-02.jpg"
              alt=""
            />
            <img
              src="../assets/shield-banners/shield-bios-banner-02.jpg"
              alt=""
            />
          </picture>
        </div>

        <div class="copy">
          <h2>SHIELD MAINTENANCE</h2>
          <p>
            We started this business based on a very simple idea – “Sometimes
            stuff breaks.” At Shield Maintenance, we know how to fix “that
            stuff.” By keeping the equipment functioning as intended, our
            clients can focus on running their business, instead of
            troubleshooting maintenance issues. Our clients rely on us as a
            trusted resource to oversee and maintain their
            facility/building/business properly, year-round. Whether they are in
            a pinch to clear a clogged drain, make an emergency building repair,
            or fix the AC on a hot day, they know they can call us and we will
            take care of them, either as part of a service agreement or as a
            one-time service call. No matter the problem, Shield Maintenance
            wants to be your first call.
          </p>

          <p>
            None of us at Shield Maintenance are afraid of getting our hands
            dirty. From top to bottom, we are all ready to jump in, and get to
            work to help identify the issue, and fix the problem. We know if
            your equipment is off line, or down, that affects your business, and
            ultimately costs YOU money. Our goal is to make sure your facility
            runs at peak efficiency, at all times. With a monthly maintenance
            service agreement, we can keep an eye on your facility heading off
            potential problems with regular maintenance and service. The bottom
            line is, we believe maintaining your facility and equipment on an
            ongoing basis saves you money in the long run. For a site assessment
            and free service agreement estimate, please call Jacob at our main
            number (817) 754-0470, or on his cell phone at (817) 401-5990.
          </p>

          <h2>SHIELD MAINTENANCE SERVICES</h2>
          <p>
            From a clogged drain, or sewer line, to routine repair of HVAC
            equipment, changing out lamps, air filters, cleaning coils,
            servicing hot and cold line equipment, plumbing systems, back-flow
            prevention, hood cleaning, and more, Shield Maintenance services are
            available on an as-needed-basis (per call), or through a maintenance
            service agreement. For a site assessment and free service agreement
            estimate, please call Jacob at our main number (817) 754-0470, or on
            his cell phone at (817) 401-5990.
          </p>
        </div>
      </div>
    </div>

    <ShieldFooter />
  </section>
</template>

<script>
import ShieldHeader from "@/components/ShieldHeader.vue";
import ShieldNavigation from "@/components/ShieldNavigation.vue";
import ShieldFooter from "@/components/ShieldFooter.vue";

export default {
  name: "ShieldHome",
  components: {
    ShieldHeader,
    ShieldNavigation,
    ShieldFooter
  }
};
</script>

<style lang="scss" scoped>
.content {
  background: #fff;
  min-height: 50vh;
}

.section-link {
  text-decoration: none;
}

.section-link:link,
.section-link:visited {
  color: #444;
}
</style>
